'use client';

import GetQuote from './GetQuote';

export default GetQuote;
